import ScrollTopOnMount from "../../Layout/ScrollTopOnMount";
import Footer from "../../Layout/Footer";
import { useNavigate } from "react-router-dom";
import HeaderLogo from "../../common/HeaderLogo";
import { GrClose } from "react-icons/gr";

const WelcomeToAssessment = () => {
  const navigate = useNavigate();

  const handleContinue = () => {
    const userData = localStorage.getItem("user");

    if (userData) {
      navigate("/assessment-info");
    } else {
      navigate("/signup");
    }
  };

  const handleExitButtonClick = () => {
    navigate("/home");
  };

  return (
    <>
      <ScrollTopOnMount />

      <section className="welcome_assessement_block">
        <div onClick={handleExitButtonClick} class="exit_button">
          <GrClose size={20} />
        </div>

        <div className="top_part">
          <div className="hero">Welcome</div>
          <div className="sub">to the Body Solutions Assessment</div>
          <HeaderLogo />
        </div>

        <div className="main_content">
          <div class="container">
            <div class="header_bold lg">
              Before we get started, here’s what to expect:
            </div>

            <ul class="instruction_list sm">
              <li>Your assessment takes 30-45 minutes</li>
              <li>Start with a quick 5-minute intake form</li>
              <li>Wear form-fitting clothing (explained in the video)</li>
              <li>Use your phone to take videos or images</li>
              <li>Create a free account to save your results</li>
            </ul>
            <ul class="instruction_list lg">
              <li>
                The full movement assessment takes about 30-45 minutes to
                complete
              </li>
              <li>
                Start with a quick 5-minute intake form to share injury history
                and goals
              </li>
              <li>Wear form-fitting clothing (explained in the video)</li>
              <li>You will take images of yourself using your phone</li>
              <li>
                Yes, a free account is required to save your results and
                customize your program
              </li>
            </ul>

            <div class="header_bold bottom_text ">
              <span>
                Let’s get started <span className="dot">.</span>{" "}
                <span className="mark">!</span>{" "}
              </span>{" "}
              <span> We’ll walk you through everything step-by-step <span className="dot">!</span></span>
            </div>

            <div class="end_block">
              <button onClick={handleContinue} class="ms-cta-btn">
                Continue
              </button>

              <p class="link_text">
                If you don’t have an account, you’ll be guided to create one.{" "}
                <br />
                If you already have an account, clicking CONTINUE will take you
                straight to the next step.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default WelcomeToAssessment;
